<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Edit Uploaded List</h1>
            <div class="content-wrap">               
                <form >
                    <div id="multiplyWrap">
                        <div class="multiply" >
                            <form [formGroup]="editassociateDocList">
                            <div class="row">
                                <!-- <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="firstName" class="form-label">Student Name</label>
                                        <input type="text" placeholder="Enter student name" formControlName="firstName"
                                         class="form-control form-input" id="firstName" [(ngModel)]="firstName">
                                        <div class="invalid-feedback">
                                            <div>Student Name is required</div>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="lastName" class="form-label">Student Surname</label>
                                        <input type="text" placeholder="Enter student surname" formControlName="lastName" 
                                        class="form-control form-input" id="lastName" [(ngModel)]="lastName">
                                        <div class="invalid-feedback">
                                            <div>Student Surname is required</div>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="enrollmentNo" class="form-label">Seat No.</label>
                                        <input type="text" placeholder="Enter Seat no." formControlName="enrollmentNo" 
                                        class="form-control form-input" id="enrollmentNo"  [(ngModel)]="enrollNo" >
                                        <div class="invalid-feedback">
                                            <div>Seat no. is required</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="collegeName" class="form-label">College Name</label>
                                        <select formControlName="collegeId" class="form-control form-input"
                                            [(ngModel)]="collegeId">
                                            <option value="undefined" disabled selected> Please select Year</option>
                                            <option *ngFor="let college of collegeDropDown" [ngValue]="college.id">
                                            {{college.collegeName}}</option>
                                        </select>
                                        <div class="invalid-feedback">
                                            <div>College name is required</div>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="stream" class="form-label">Stream</label>
                                        <select formControlName="streamId" class="form-control form-input"
                                        [(ngModel)]="streamId"  (change)='getBranAndStream($event.target.value)'>
                                            <option selected disabled value="undefined">Select your stream</option>
                                            <option *ngFor="let stream of streamDropDown" [ngValue]="stream.id">
                                                {{stream.streamName}}</option>
                                        </select>
                                        <div class="invalid-feedback">
                                            <div>Stream is required</div>
                                        </div>
                                    </div>
                                </div>                               
                                <!-- <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="branch" class="form-label">Branch</label>
                                        <select formControlName="branchId" class="form-control form-input"  [(ngModel)]="branchId">
                                            <option value="undefined" disabled selected> Please select Branch </option>
                                            <option *ngFor="let branch of branchDropDown" [ngValue]="branch.id">
                                                {{branch.branchName}}</option>
                                        </select>
                                    </div>
                                </div> -->
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="semester" class="form-label">Semester</label>
                                        <select formControlName="semId" class="form-control form-input"  [(ngModel)]="semId">
                                            <option value="undefined" disabled selected> Please select Semester </option>
                                            <option *ngFor="let semester of semesterDropDown" [ngValue]="semester.id">
                                                {{semester.semester}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="passingYear" class="form-label">Year of Passing</label>
                                        <!-- <select formControlName="passingYearId" class="form-control form-input"
                                            [(ngModel)]="yearOfPassId">
                                            <option value="undefined" disabled selected> Please select Year</option>
                                            <option *ngFor="let year of YearOfPassDropDown" [ngValue]="year.id">
                                            {{year.yearOfPassing}}</option>
                                        </select> -->
                                        <mat-form-field>
                                            <input matInput [matDatepicker]="dp" placeholder="Select Month and Year" id="yearOfPassId"  
                                            formControlName="passingYearId"  [matDatepickerFilter]=dateFilter  autocomplete="off">
                                            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                                            <mat-datepicker #dp
                                                            startView="multi-year"
                                                            (yearSelected)="chosenYearHandler($event)"
                                                            (monthSelected)="chosenMonthHandler($event, dp)"
                                                            panelClass="example-month-picker">
                                            </mat-datepicker>
                                          </mat-form-field>
                                        <div class="invalid-feedback">
                                            <div>Year of passing is required</div>
                                        </div>
                                    </div>
                                </div>                               
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="collegeName" class="form-label">Uploaded Document</label>
                                        <!-- <a href="#" data-toggle="modal" data-target="#viewModal"><img src="../../assets/images/certificate.jpg" alt="Certificate" class="doc-img"></a> -->
                                        <!-- <a href="#" data-toggle="modal" data-target="#viewModal">
                                            <img [src]="originalDocUploadFilePath" alt="Certificate" class="doc-img"></a> -->
                                            <div *ngIf="isUPdf">
                                                <div class="ng-star-inserted22">
                                                  <pdf-viewer [src]="src1" [zoom]="1"></pdf-viewer>
                                                </div>
                                                <button class="new-tab-btn" (click)="openPdf1()">Open Doc in Browser</button>
                                              </div>
                                              <div *ngIf="isUImage">
                                              <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)" loading="lazy">
                                            </div>
                                        <div>
                                            <label for="originalDocUploadFilePath" class="form-label">Upload New Document</label>
                                            <input formControlName="originalDocUploadFilePath" type="file"
                                            class="form-control form-input border-none" accept=".png,.jpg,.jpeg,.tiff,.pdf"
                                            id="originalDocUploadFilePath" (change)="catchEvent($event.target.files)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input placeholder="filePath" formControlName="filePath" hidden>
                        </form>
                        </div>
                        </div>
                        <button class="proceed-btn bg-theme" (click)="onSubmit()">Submit</button>
                        <button class="proceed-btn  bg-theme" (click)="callRoute(31)">Cancel</button>
                        </form>
                    </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="viewModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header bg-theme">
              <h5 class="modal-title" id="viewModalLabel">Uploaded Document</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <p class="doc-txt">Uploaded file</p>
               <img [src]="originalDocUploadFilePath" alt="Certificate" class="doc-img"> 
      
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 

      <ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
        let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

<div class="modal-content">
    <div class="modal-header success-modal-header">
        <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
            <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            <!-- <i class="fa fa-check fa-icon-modal"
                aria-hidden="true"></i> -->
            </h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <h3 class="success-text">Success</h3>
                <p class="reset-hd2">Record has been updated.</p>
            </div>
        </div>
        <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
</div>
<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>